import React from 'react';
import { motion } from 'framer-motion';

const team = [
  {
    name: 'Lee Sommers',
    role: 'Marketing Strategy & Growth',
    company: 'Sommers Marketing Group',
    desc: 'Lee leads marketing strategy, campaign planning, brand positioning, and overall growth initiatives. He ensures every channel supports a clear business objective.',
    img: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=400&h=400&auto=format&fit=crop'
  },
  {
    name: 'Anthony Idi',
    role: 'Digital Strategy & Web Dev',
    company: 'Dapper Dev LLC',
    desc: 'Anthony connects business strategy with the digital platforms and technical infrastructure required to execute it, spanning SEO, ads, and software planning.',
    img: 'https://images.unsplash.com/photo-1504257432389-52343af06ae3?q=80&w=400&h=400&auto=format&fit=crop'
  },
  {
    name: 'Joseph Idi',
    role: 'Dev & Technical Solutions',
    company: 'Dapper Dev LLC',
    desc: 'Joseph focuses on platform functionality, system integrations, and custom features, ensuring the technology behind each strategy is reliable and scalable.',
    img: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=400&h=400&auto=format&fit=crop'
  }
];

const StoryAndTeam = () => {
  return (
    <section id="team" className="light-section section-padding relative bg-white">
      <div className="container-custom">
        
        {/* Story Section */}
        <div className="max-w-4xl mx-auto mb-32 text-center">
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
          >
            <span className="text-purple-600 font-medium tracking-widest text-base uppercase mb-4 block font-display">
              How LAJ Digital Started
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-gray-900 mb-8">
              Ten Years of Collaboration Led to <br className="hidden md:block" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-500">One Company.</span>
            </h2>
            
            <div className="text-lg text-gray-600 space-y-6 font-light">
              <p>LAJ Digital was founded by Lee Sommers, Anthony Idi, and Joseph Idi after more than a decade of working together across different companies, roles, and digital projects.</p>
              <p>Businesses were trying to coordinate marketing strategy, website development, advertising, software, and customer management through disconnected providers. Each provider understood one part, but no one connected all of it.</p>
              
              <p className="font-display font-medium text-gray-900 text-xl p-6 bg-gray-50 border border-gray-200 rounded-2xl mt-8">
                By combining the strategic marketing experience of Sommers Marketing Group with the technical capabilities of Dapper Dev LLC, we solve challenges that do not fit neatly into a single service category.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Team Section */}
        <div className="text-center mb-16">
          <span className="text-cyan-600 font-medium tracking-widest text-base uppercase mb-4 block font-display">
            Meet The Founders
          </span>
          <h2 className="text-4xl lg:text-5xl font-display font-bold text-gray-900">
            The People Behind LAJ Digital
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {team.map((member, idx) => (
            <motion.div 
              key={member.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ delay: idx * 0.15 }}
              className="bg-white rounded-3xl overflow-hidden shadow-lg border border-gray-100 group hover:shadow-2xl hover:-translate-y-2 transition-all duration-500"
            >
              <div className="aspect-square w-full relative overflow-hidden">
                <div className="absolute inset-0 bg-cyan-500/10 mix-blend-overlay z-10 group-hover:opacity-0 transition-opacity duration-500"></div>
                <img 
                  src={member.img} 
                  alt={member.name} 
                  className="w-full h-full object-cover filter grayscale group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-100"
                />
                <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-white via-white/80 to-transparent z-20"></div>
              </div>
              
              <div className="p-8 relative z-30 -mt-12">
                <h3 className="text-2xl font-display font-bold text-gray-900 mb-1">{member.name}</h3>
                <p className="text-cyan-600 font-medium text-base mb-4 tracking-wide uppercase">{member.role}</p>
                
                <span className="inline-block border border-gray-200 bg-gray-50 text-gray-700 text-sm px-4 py-1.5 rounded-full font-medium mb-6">
                  {member.company}
                </span>
                
                <p className="text-gray-600 text-base font-light leading-relaxed">
                  {member.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default StoryAndTeam;